import { FilterSelection, RouteBlockInterface, RouteScheduleInterface } from '@/types';
import { getAverageScheduleRouteEmissions } from '@/utils/emissions';

interface Props {
  schedules: RouteScheduleInterface[];
  filters: FilterSelection;
  filteringFunc: <T extends RouteBlockInterface | RouteScheduleInterface>(
    options: T[],
    filters: FilterSelection,
  ) => T[];
  isArriveByDate: boolean;
}

const getSortedAndFilterSchedules = ({ schedules, filters, filteringFunc, isArriveByDate }: Props) => {
  const sortedSchedules = [...schedules].sort((a, b) => {
    if (isArriveByDate) {
      return new Date(b.arrivalDateTime).valueOf() - new Date(a.arrivalDateTime).valueOf();
    }
    return new Date(a.departureDateTime).valueOf() - new Date(b.departureDateTime).valueOf();
  });

  const filteredSchedules = filteringFunc(sortedSchedules, filters);

  const emissionStats = getAverageScheduleRouteEmissions(filteredSchedules);

  return { filteredSchedules, emissionStats };
};

export { getSortedAndFilterSchedules };
